import { useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import AdminExecutionsPage from "./components/AdminExecutionsPage";
import AuthButton from "./components/AuthButton";
import CoordinatorPage from "./components/CoordinatorPage";
import Header from "./components/Header";
import ReportingWorkspace from "./components/ReportingWorkspace";
import { useI18n } from "./i18n";
import StoragePage from "./pages/StoragePage";
import TemplatesPage from "./pages/TemplatesPage";
import { isAdminAccount } from "./utils/accountRoles";

function sanitizeEnvUrl(value) {
  if (!value) {
    return "";
  }
  return value.replace(/^["']|["']$/g, "").trim();
}

function resolveApiUrl() {
  const isLocalEnvironment = typeof window !== "undefined" && window.location.hostname === "localhost";
  if (isLocalEnvironment) {
    return sanitizeEnvUrl(process.env.REACT_APP_API_URL_LOCAL || process.env.REACT_APP_API_URL);
  }
  return sanitizeEnvUrl(process.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL_LOCAL);
}

const App = () => {
  const { accounts } = useMsal();
  const { t } = useI18n();
  const backendBaseUrl = resolveApiUrl();
  const isAdmin = isAdminAccount(accounts[0]);
  
  useEffect(() => {
    const wakeupBackend = async () => {
      try {
        console.log("Tentative de réveil du backend à:", backendBaseUrl);
        const response = await fetch(`${backendBaseUrl}/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          // Ajouter un timeout pour éviter les attentes trop longues
          signal: AbortSignal.timeout(5000)
        });
        
        if (response.ok) {
          console.log('🚀 Backend réveillé avec succès');
        } else {
          console.warn('⚠️ Le backend a répondu avec une erreur:', response.status);
        }
      } catch (error) {
        console.error('❌ Erreur lors du réveil du backend:', error);
        // Ne pas bloquer l'application si le backend n'est pas disponible
      }
    };

    wakeupBackend();
  }, [backendBaseUrl]);

  return (
    <Router>
      <div>
        <Header />
        <div className="content">
          {accounts.length > 0 ? (
            <Routes>
              <Route path="/" element={<ReportingWorkspace />} />
              <Route path="/storage" element={<StoragePage />} />
              <Route
                path="/admin"
                element={isAdmin ? <AdminExecutionsPage /> : <Navigate to="/" replace />}
              />
              <Route
                path="/coordinator"
                element={isAdmin ? <CoordinatorPage /> : <Navigate to="/" replace />}
              />
              <Route
                path="/templates"
                element={isAdmin ? <TemplatesPage /> : <Navigate to="/" replace />}
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          ) : (
            <div className="login-gate">
              <div className="login-card">
                <h2 className="login-title">{t("login_title")}</h2>
                <p className="login-gate-text">
                  {t("login_gate_text")}
                </p>
                <AuthButton />
              </div>
            </div>
          )}
        </div>
      </div>
    </Router>
  );
};

export default App;
